import { render, staticRenderFns } from "./ShippingAndPayments.vue?vue&type=template&id=6381fd06&"
import script from "./ShippingAndPayments.vue?vue&type=script&lang=js&"
export * from "./ShippingAndPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports